import { Link } from 'react-router-dom';

const SiteFooter = () => (
  <footer className="site-footer">
    <div>
      <Link className="footer-brand" to="/">Jupiter Cosmic</Link>
      <p>AI that understands how your business works.</p>
    </div>
    <nav aria-label="Footer navigation">
      <Link to="/#products">Products</Link>
      <Link to="/#how-it-works">How It Works</Link>
      <Link to="/#about">About</Link>
      <Link to="/#pilot">Contact</Link>
    </nav>
  </footer>
);

export default SiteFooter;
